import script from "./ResetPasswordTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordTile.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordTile.vue?vue&type=style&index=0&id=e6bd94be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6bd94be"]])

export default __exports__